import React from "react";
import "./WhyChooseGrowboo.css";

const FeatureCard = ({ icon, title, description }) => {
  return (
    <div className="growboo-card">
      <div className="card-icon">{icon}</div>
      <h3 className="card-title">{title}</h3>
      <p className="card-description">{description}</p>
    </div>
  );
};

const WhyChooseGrowboo = () => {
  // SVG Icons defined here for portability
  const MonitorIcon = (
    <svg
      width="60"
      height="60"
      viewBox="0 0 24 24"
      fill="none"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
      <line x1="8" y1="21" x2="16" y2="21"></line>
      <line x1="12" y1="17" x2="12" y2="21"></line>
    </svg>
  );

  const HandsIcon = (
    <svg
      width="60"
      height="60"
      viewBox="0 0 24 24"
      fill="none"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path
        d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"
        style={{ display: "none" }}
      />{" "}
      {/* Hidden Heart reference */}
      <path d="M20.42 4.82A5.23 5.23 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.23 5.23 0 0 0 3.58 4.82"></path>
      {/* Custom stylized hands similar to image */}
      <path d="M7 12l-4 2c0 4 3 6 9 6s9-2 9-6l-4-2" />
      <path d="M12 20v-2" />
      <path d="M7 12v-3" />
      <path d="M17 12v-3" />
    </svg>
  );

  const BankIcon = (
    <svg
      width="60"
      height="60"
      viewBox="0 0 24 24"
      fill="none"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="2" y1="22" x2="22" y2="22"></line>
      <line x1="6" y1="18" x2="6" y2="11"></line>
      <line x1="10" y1="18" x2="10" y2="11"></line>
      <line x1="14" y1="18" x2="14" y2="11"></line>
      <line x1="18" y1="18" x2="18" y2="11"></line>
      <polygon points="12 2 2 7 22 7 12 2"></polygon>
      <rect x="2" y="18" width="20" height="4"></rect>
    </svg>
  );

  const features = [
    {
      id: 1,
      icon: MonitorIcon,
      title: "High Returns",
      description:
        "Enjoy 8–10% profit each Month, giving you steady monthly growth without unnecessary risk.",
    },
    {
      id: 2,
      icon: HandsIcon, // Using a stylized version of hands
      title: "Secure & Transparent",
      description:
        "Your funds are protected with top-tier security measures, and our operations are fully transparent—no hidden charges or surprises.",
    },
    {
      id: 3,
      icon: BankIcon,
      title: "Easy Withdrawals",
      description:
        "Access your profits conveniently at the end of every month with a smooth and hassle-free withdrawal process.",
    },
  ];

  return (
    <div className="why-choose-growboo-container">
      <h2 className="section-heading">Why Choose Grow Bizint International?</h2>
      <div className="cards-grid">
        {features.map((feature) => (
          <FeatureCard
            key={feature.id}
            icon={feature.icon}
            title={feature.title}
            description={feature.description}
          />
        ))}
      </div>
    </div>
  );
};

export default WhyChooseGrowboo;
